import { io } from "socket.io-client";
import { BASEURL_API } from "../static/data/constants";
import { getSocketAuth } from "../api/requestSigning";

let socket = null;
let publicSocket = null;

// Every item-change hint emitted by the backend. On any of these, re-fetch the
// item list for the open shipment (REST stays the single source of truth).
export const REFETCH_EVENTS = [
	"item-created",
	"item-updated",
	"item-deleted",
	"item-voided",
	"item-assigned-to-unit",
	"item-unassigned-from-unit",
	"item-scanned",
	"item-exceptions-updated",
];

// Generic company-room hint (fields: shipment_job_id, company_id, changeType)
// emitted to the whole company. Useful for multi-shipment list/dashboard screens
// that are not inside a single shipment room.
export const SHIPMENT_ITEMS_CHANGED_EVENT = "shipment-items-changed";

// The socket connects to the SAME base URL as the REST API handler
// (BASEURL_API) so it always targets the host running the Socket.IO server.
// Falls back to the current origin when it is not set.
function getSocketUrl() {
	const url =
		BASEURL_API || (typeof window !== "undefined" ? window.location.origin : "");
	return url ? url.replace(/\/+$/, "") : url;
}

export function getSocket() {
	if (socket) return socket;

	const token = localStorage.getItem("access_token");

	socket = io(getSocketUrl(), {
		path: "/socket.io",
		// Start with long-polling and let Socket.IO upgrade to WebSocket when the
		// server/proxy supports it. Forcing "websocket" only fails behind proxies
		// that don't upgrade the raw WebSocket handshake.
		transports: ["polling", "websocket"],
		// Signed fresh on every (re)connect, so the server knows the handshake
		// comes from the browser that logged in.
		auth: (cb) => {
			getSocketAuth(token).then(cb);
		},
		reconnection: true,
		reconnectionAttempts: Infinity,
		reconnectionDelay: 1000,
	});

	return socket;
}

export function disconnectSocket() {
	if (socket) {
		socket.disconnect();
		socket = null;
	}
}

// Anonymous (token-less) socket for the public customer portal. Viewers have no
// access_token, so this connects without auth and uses the public read-only
// join flow (join-shipment-public) on the server.
export function getPublicSocket() {
	if (publicSocket) return publicSocket;

	publicSocket = io(getSocketUrl(), {
		path: "/socket.io",
		transports: ["polling", "websocket"],
		reconnection: true,
		reconnectionAttempts: Infinity,
		reconnectionDelay: 1000,
	});

	return publicSocket;
}

export function disconnectPublicSocket() {
	if (publicSocket) {
		publicSocket.disconnect();
		publicSocket = null;
	}
}
